import { render, staticRenderFns } from "./VueSelectTempGender.vue?vue&type=template&id=5318c8a1&scoped=true&"
import script from "./VueSelectTempGender.vue?vue&type=script&lang=js&"
export * from "./VueSelectTempGender.vue?vue&type=script&lang=js&"
import style0 from "./VueSelectTempGender.vue?vue&type=style&index=0&id=5318c8a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318c8a1",
  null
  
)

export default component.exports